<template>
  <div class="user-order">
    <el-table fit height="496" :data="list" header-cell-class-name="table-header-cell">
      <el-table-column label="订单号" prop="orderNumber" width="120" align="center" :fixed="device !== 'mobile'" />
      <el-table-column label="支付单号" prop="payNumber" width="120" align="center" />
      <el-table-column label="下单时间" prop="orderTime" width="100" align="center">
        <template slot-scope="{row}">
          <div>{{ row.orderTime | filterDate }}</div>
          <div>{{ row.orderTime | filterTime }}</div>
        </template>
      </el-table-column>
      <el-table-column label="商品信息" min-width="250">
        <template slot-scope="{row}">
          <div v-for="(item, pid) in row.products" :key="pid" class="flex align-start just-between">
            <el-image class="product-cover" :src="item.cover" :preview-src-list="[item.cover]" lazy />
            <div class="flex-sub">{{ item.goodsName }}</div>
            <div class="sku-count">{{ `x${item.skuCount}` }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="配送方式" prop="deliveryMethodName" width="80" align="center" />
      <el-table-column label="订单金额" prop="orderPrice" min-width="90" align="right">
        <template slot-scope="{row}">
          <template v-if="row.orderType === 72000">
            <div class="space-nowrap"><span class="bold">总金额：</span><span>{{ row.orderPrice | filterInteger }}</span></div>
            <div class="space-nowrap"><span class="bold">积分：</span><span>{{ row.orderPoint | filterInteger }}</span></div>
            <div class="space-nowrap"><span class="bold">券：</span><span>{{ row.orderCoupon | filterInteger }}</span></div>
          </template>
          <template v-else-if="row.orderType === 73000">
            <span class="bold">积分：</span>{{ row.orderPoint | filterInteger }}
          </template>
          <template v-else-if="row.orderType === 75000">
            <div class="space-nowrap"><span class="bold">现金：</span><span>{{ row.orderPrice | filterPrice }}</span></div>
            <div v-if="parseFloat(row.orderPoint) > 0" class="space-nowrap"><span class="bold">积分：</span><span>{{ row.orderPoint | filterPrice }}</span></div>
            <div v-if="parseFloat(row.orderCoupon) > 0" class="space-nowrap"><span class="bold">券：</span><span>{{ row.orderCoupon | filterPrice }}</span></div>
          </template>
          <template v-else-if="row.orderType === 76000">
            <div class="space-nowrap"><span class="bold">积分：</span><span>{{ row.orderPoint | filterInteger }}</span></div>
            <div class="space-nowrap"><span class="bold">券：</span><span>{{ row.orderCoupon | filterInteger }}</span></div>
          </template>
          <template v-else-if="row.orderType === 77000">
            <template v-if="row.payMethod === 0">
              <span class="bold">积分：</span>{{ row.orderPoint | filterInteger }}
            </template>
            <template v-else>
              <div class="space-nowrap"><span class="bold">现金：</span><span>{{ row.orderPrice | filterPrice }}</span></div>
              <div v-if="row.payMethod === 2" class="space-nowrap"><span class="bold">积分：</span><span>{{ row.orderPoint | filterPrice }}</span></div>
            </template>
          </template>
        </template>
      </el-table-column>
      <el-table-column label="状态" prop="orderStatusName" width="80" align="center">
        <template slot-scope="{row}">
          <el-tag v-if="row.orderStatus >= 51" type="success" size="medium" effect="dark">{{ row.orderStatusName }}</el-tag>
          <el-tag v-else-if="row.orderStatus === 13" type="info" size="medium" effect="dark">{{ row.orderStatusName }}</el-tag>
          <el-tag v-else-if="row.orderStatus === 41" type="warning" size="medium" effect="dark">{{ row.orderStatusName }}</el-tag>
          <el-tag v-else-if="row.orderStatus === 21" type="danger" size="medium" effect="plain">{{ row.orderStatusName }}</el-tag>
          <el-tag v-else size="medium" effect="dark">{{ row.orderStatusName }}</el-tag>
        </template>
      </el-table-column>
    </el-table>

    <pagination :total="total" :page.sync="queryParams.page" :limit.sync="queryParams.limit" layout="total, sizes, prev, pager, next" @pagination="fetchData" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getOrderList } from '@/api/order'
import Pagination from '@/components/Pagination'

export default {
  name: 'UserOrder',
  components: { Pagination },
  props: {
    memberId: {
      type: [Number, String],
      default: ''
    }
  },
  data() {
    return {
      list: [],
      total: 0,
      queryParams: {
        orderStatus: '0',
        memberId: '',
        page: 1,
        limit: 10
      }
    }
  },
  computed: mapGetters(['device']),
  mounted() {
    this.queryParams = Object.assign({}, this.queryParams, {
      memberId: this.memberId
    })
    this.fetchData()
  },
  methods: {
    fetchData() {
      getOrderList(this.queryParams).then(response => {
        this.list = response.records
        this.total = response.total
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.user-order {
  .product-cover {
    width: 50px;
    height: 50px;
    min-width: 50px;
    border-radius: 4px;
    margin-right: 10px;
  }
  .sku-count {
    font-weight: 600;
    margin-left: 10px;
    white-space: nowrap;
  }
  .space-nowrap {
    span {
      white-space: nowrap;
    }
  }
  ::v-deep {
    .pagination-container {
      margin-top: 20px;
      padding: 0 10px 20px;
    }
  }
}
</style>
